/*
  PWP: never let a shopper land on a sold-out combination.

  Values nothing can be bought in are disabled in the markup
  (product-variant-options.liquid). A value that IS buyable, but not with
  the options already picked, stays tappable; when it is tapped this moves
  the other options to the nearest buyable variant before Dawn reads the
  selection. Found 2026-10-22 in Clarity: on the marquise (6 of 64 variants
  in stock) the most-tapped controls were the metal and carat swatches and
  every Two-Tone tap ended at "Sold out".

  Runs in the capture phase on document, so it adjusts the inputs before
  variant-selects' own change listener publishes the selection.
*/
(function () {
  if (window.__pwpVariantGuard) return;
  window.__pwpVariantGuard = true;

  function groupsOf(picker) {
    return Array.prototype.slice.call(
      picker.querySelectorAll('fieldset.product-form__input, .product-form__input--dropdown')
    );
  }

  function valuesOf(group) {
    var select = group.querySelector('select');
    var nodes = select ? select.options : group.querySelectorAll('input[type="radio"]');
    return Array.prototype.map.call(nodes, function (n) { return n.value; });
  }

  function selectedOf(group) {
    var select = group.querySelector('select');
    if (select) return select.value;
    var checked = group.querySelector('input[type="radio"]:checked');
    return checked ? checked.value : null;
  }

  function choose(group, value) {
    var select = group.querySelector('select');
    if (select) {
      Array.prototype.forEach.call(select.options, function (o) {
        if (o.value === value) {
          o.setAttribute('selected', 'selected');
          o.selected = true;
        } else {
          o.removeAttribute('selected');
        }
      });
      return;
    }
    var inputs = group.querySelectorAll('input[type="radio"]');
    Array.prototype.forEach.call(inputs, function (i) {
      if (i.value === value) {
        i.checked = true;
        var label = group.querySelector('[data-selected-value]');
        if (label) label.textContent = value;
      }
    });
  }

  document.addEventListener(
    'change',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;
      var picker = target.closest('variant-selects');
      if (!picker) return;
      var data = picker.querySelector('script[data-pwp-variants]');
      if (!data) return;
      var variants;
      try {
        variants = JSON.parse(data.textContent);
      } catch (e) {
        return;
      }
      if (!variants.length) return;

      var groups = groupsOf(picker);
      if (groups.length !== variants[0][0].length) return;
      var changed = groups.indexOf(target.closest('fieldset.product-form__input, .product-form__input--dropdown'));
      if (changed < 0) return;

      var wanted = groups.map(selectedOf);
      var exact = variants.some(function (v) {
        return v[1] && v[0].every(function (o, i) { return o === wanted[i]; });
      });
      if (exact) return;

      // Nearest buyable variant that keeps the value just tapped: keep as
      // many of the other picks as possible (earlier options weigh more),
      // then the closest neighbours in each row.
      var lists = groups.map(valuesOf);
      var best = null;
      var bestScore = -Infinity;
      variants.forEach(function (v) {
        if (!v[1] || v[0][changed] !== wanted[changed]) return;
        var score = 0;
        v[0].forEach(function (o, i) {
          if (i === changed) return;
          if (o === wanted[i]) {
            score += Math.pow(10, groups.length - i) * 10;
          } else {
            var d = Math.abs(lists[i].indexOf(o) - lists[i].indexOf(wanted[i]));
            score -= d;
          }
        });
        if (score > bestScore) {
          bestScore = score;
          best = v;
        }
      });
      if (!best) return;

      best[0].forEach(function (o, i) {
        if (i !== changed && o !== wanted[i]) choose(groups[i], o);
      });
    },
    true
  );
})();
